module.exports = __webpack_public_path__ + "img/未标题-14.6ea5375a.png";